import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.types';

// Validate environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error(
        'Missing Supabase environment variables. Please check your .env.local file.'
    );
}

// Create Supabase client with TypeScript types
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
});

// Helper to check if user is authenticated
export const isAuthenticated = async (): Promise<boolean> => {
    const {
        data: { session },
    } = await supabase.auth.getSession();
    return !!session;
};

// Helper to get current user
export const getCurrentUser = async () => {
    const {
        data: { user },
    } = await supabase.auth.getUser();
    return user;
};

// Helper to get current session
export const getCurrentSession = async () => {
    const {
        data: { session },
    } = await supabase.auth.getSession();
    return session;
};

